import { createContext as e, useContext as t } from "react";
import { useTranslation as n } from "@maat/store-i18n";
import { jsx as r } from "react/jsx-runtime";
//#region src/components/Table/TableProvider.tsx
var i = e(null), a = ({ children: e, data: t, selectedRows: a = [], onSelectionChange: o, isLoading: s = !1, isFetchingNextPage: c = !1, emptyMessage: l, maxHeight: u, scrollTargetRef: d }) => {
	let { t: f } = n("ds");
	return /* @__PURE__ */ r(i.Provider, {
		value: {
			data: t,
			selectedRows: a,
			onSelectionChange: o,
			isLoading: s,
			isFetchingNextPage: c,
			emptyMessage: l ?? f("ds:table.empty"),
			maxHeight: u,
			scrollTargetRef: d
		},
		children: e
	});
}, o = () => {
	let e = t(i);
	if (!e) throw Error("Table components must be used within a TableProvider");
	return e;
}, s = () => t(i);
//#endregion
export { a as TableProvider, s as useOptionalTableContext, o as useTableContext };
